/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rate: NonNullable<unknown> }} User_Detail_Win_RateInputs */



/**
* | output |
* | --- |
* | "Win rate: {rate}%" |
*
* @param {User_Detail_Win_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_win_rate = /** @type {((inputs: User_Detail_Win_RateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Win_RateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Taux de victoire : ${i?.rate} %`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Tasa de victoria: ${i?.rate} %`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Taxa de vitória: ${i?.rate}%`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Percentuale di vittorie: ${i?.rate}%`)
	return /** @type {LocalizedString} */ (`Win rate: ${i?.rate}%`)
});